import {Injectable, Output, EventEmitter} from '@angular/core';

@Injectable()
export class ApexChartService {
  @Output() changeTimeRange: EventEmitter<boolean> = new EventEmitter();
  @Output() changeSeriesData: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  eventChangeTimeRange() {
    this.changeTimeRange.emit();
    console.log(this.changeTimeRange);
  }

  eventChangeSeriesData() {
    this.changeSeriesData.emit();
    console.log(this.changeSeriesData);
  }
}
